import { render, staticRenderFns } from "./BillingDocumentQuickListItem.vue?vue&type=template&id=71a74321&scoped=true"
import script from "./BillingDocumentQuickListItem.vue?vue&type=script&lang=js"
export * from "./BillingDocumentQuickListItem.vue?vue&type=script&lang=js"
import style0 from "./BillingDocumentQuickListItem.vue?vue&type=style&index=0&id=71a74321&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a74321",
  null
  
)

export default component.exports